import * as React from "react";
import { connect } from "react-redux";

import TermsandCondition from "../../screens/Settings/TermsandCondition";
import {
  fetchTermsandCondition,
  AddTrmsadCndtn,
  EditTrmsadCndtn
} from "./action";
class TermsandConditionContainer extends React.Component<Props, State> {
  render() {
    return (
      <TermsandCondition
        fetchTermsandCondition={this.props.fetchTermsandCondition}
        AddTrmsadCndtn={this.props.AddTrmsadCndtn}
        TrmsadCondtonDtList={this.props.TrmsadCondtonDtList}
        TrmsadCondtonCount={this.props.TrmsadCondtonCount}
        EditTrmsadCndtn={this.props.EditTrmsadCndtn}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    fetchTermsandCondition: () => {
      dispatch(fetchTermsandCondition());
    },
    AddTrmsadCndtn: value => {
      dispatch(AddTrmsadCndtn(value));
    },
    EditTrmsadCndtn: value => {
      dispatch(EditTrmsadCndtn(value));
    }
  };
}
function mapStateToProps(state) {
  return {
    TrmsadCondtonDtList: state.TermsandConditionReducer.TrmsadCondtonDtList,
    TrmsadCondtonCount: state.TermsandConditionReducer.TrmsadCondtonCount
  };
}

export default connect(
  mapStateToProps,
  bindAction
)(TermsandConditionContainer);
